import script from "./FilaListasJugador.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilaListasJugador.vue?vue&type=script&setup=true&lang=ts"

import "./FilaListasJugador.vue?vue&type=style&index=0&id=5ff6250e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ff6250e"]])

export default __exports__